import React, { useState, useEffect, useRef } from 'react';
import { Card, Typography, Tag, Row, Col, Table, Divider, Button, Select, message, Descriptions, Input, Space, Modal, Form, DatePicker, Input as AntInput, Tabs, Popconfirm, Statistic, Upload, InputNumber, Steps } from 'antd';
import { ArrowLeftOutlined, FilePdfOutlined, EditOutlined, SaveOutlined, CalendarOutlined, DollarOutlined, MailOutlined, StopOutlined, ReloadOutlined, DownloadOutlined, UploadOutlined, FileProtectOutlined, SafetyCertificateOutlined } from '@ant-design/icons';
import { useParams, useNavigate } from 'react-router-dom';
import api from '../services/api';
import { PainelAssinaturas, BotoesAssinatura } from '../components/AssinaturaProposta';
import ContatoSelect from '../components/ContatoSelect';

const { Title, Text } = Typography;
const { Option } = Select;

const STATUS_CORES = { rascunho: 'default', proposta_enviada: 'blue', oc_recebida: 'cyan', agendado: 'purple', inspecionado: 'orange', laudo_emitido: 'green', nf_emitida: 'gold' };
const STATUS_LABELS = { rascunho: 'Rascunho', proposta_enviada: 'Enviada', oc_recebida: 'OC Recebida', agendado: 'Agendado', inspecionado: 'Inspecionado', laudo_emitido: 'Laudo Emitido', nf_emitida: 'NF Emitida' };

function PropostaDetalhe() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [proposta, setProposta] = useState(null);
  const [propostasProduto, setPropostasProduto] = useState([]);
  const [salvandoPecas, setSalvandoPecas] = useState(false);
  const [loading, setLoading] = useState(true);
  const [gerandoPDF, setGerandoPDF] = useState(false);
  const [modalOS, setModalOS] = useState(false);
  const [formOS] = Form.useForm();
  const [boletos, setBoletos] = useState([]);
  const [nfses, setNfses] = useState([]);
  const [modalNFSe, setModalNFSe] = useState(false);
  const [formNFSe] = Form.useForm();
  const [emitindoNFSe, setEmitindoNFSe] = useState(false);
  const [dadosNFSeRevisao, setDadosNFSeRevisao] = useState(null);
  const [etapaNFSe, setEtapaNFSe] = useState(0);
  const [modalBoleto, setModalBoleto] = useState(false);
  const [formBoleto] = Form.useForm();
  const [gerandoBoleto, setGerandoBoleto] = useState(false);
  const [modalDadosBoleto, setModalDadosBoleto] = useState(false);
  const [dadosBoleto, setDadosBoleto] = useState(null);
  const [modalCancelar, setModalCancelar] = useState(false);
  const [boletoCancelarId, setBoletoCancelarId] = useState(null);
  const [motivoCancelamento, setMotivoCancelamento] = useState('ACERTOS');
  const [editandoOC, setEditandoOC] = useState(false);
  const [uploadingOC, setUploadingOC] = useState(false);
  const [numeroOC, setNumeroOC] = useState('');

  useEffect(() => { carregarProposta(); }, [id]);

  const carregarProposta = async () => {
    try {
      setLoading(true);
      const r = await api.get(`/propostas/${id}`);
      setProposta(r.data);
      setNumeroOC(r.data.numero_oc || '');
      if (r.data.cliente_id) api.get('/propostas-produtos?cliente_id=' + r.data.cliente_id).then(rp => setPropostasProduto(rp.data || [])).catch(() => {});
      api.get('/boletos/proposta/' + id).then(rb => setBoletos(rb.data || [])).catch(() => {});
      api.get('/nfse/proposta/' + id).then(rn => setNfses(rn.data || [])).catch(() => {});
    } catch { message.error('Erro ao carregar proposta'); }
    finally { setLoading(false); }
  };

  const atualizarStatus = async (novoStatus) => {
    try {
      await api.put(`/propostas/${id}/status`, { status: novoStatus });
      message.success('Status atualizado!');
      carregarProposta();
    } catch { message.error('Erro ao atualizar status'); }
  };

  const uploadOC = async (file) => {
    try {
      setUploadingOC(true);
      const formData = new FormData();
      formData.append('arquivo', file);
      await api.post('/upload/propostas/' + id + '/oc', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      message.success('Arquivo da OC enviado!');
      const r = await api.get('/propostas/' + id);
      setProposta(r.data);
    } catch(e) { message.error('Erro ao enviar arquivo: ' + (e.response?.data?.erro || e.message)); }
    finally { setUploadingOC(false); }
    return false; // Prevenir upload automatico do antd
  };

  const verArquivoOC = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/upload/propostas/' + id + '/oc', {
        headers: { Authorization: 'Bearer ' + token }
      });
      if (!response.ok) throw new Error('Arquivo não encontrado');
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank');
    } catch(e) { message.error('Erro ao abrir arquivo'); }
  };

  const salvarOC = async () => {
    try {
      await api.put(`/propostas/${id}/oc`, { numero_oc: numeroOC });
      message.success('Ordem de compra registrada!');
      setEditandoOC(false);
      carregarProposta();
    } catch { message.error('Erro ao salvar OC'); }
  };

  const emitirBoleto = async (values) => {
    try {
      setGerandoBoleto(true);
      await api.post('/boletos/proposta/' + id, {
        vencimento: values.vencimento.format('YYYY-MM-DD'),
        valor: values.valor || proposta.valor_total,
      });
      message.success('Boleto emitido com sucesso!');
      setModalBoleto(false);
      const r = await api.get('/boletos/proposta/' + id);
      setBoletos(r.data || []);
    } catch(e) { message.error('Erro ao emitir boleto: ' + (e.response?.data?.erro || e.message)); }
    finally { setGerandoBoleto(false); }
  };

  const abrirModalNFSe = async () => {
    try {
      const r = await api.get('/nfse/proposta/' + id + '/dados');
      const d = r.data;
      formNFSe.setFieldsValue({
        descricao_servico: 'Manutencao ',
        codigo_servico: '140101',
        valor_servico: d.valor_total,
        aliquota_simples: 9.59,
        retencao_issqn: false,
        numero_proposta: d.proposta_numero,
        numero_pedido: d.numero_oc || '',
        prazo_pagamento: d.forma_pagamento || '',
        cnpj_tomador: d.cnpj_faturamento || d.cnpj,
        razao_social_tomador: d.razao_faturamento || d.razao_social,
        logradouro_tomador: d.logradouro_filial || d.logradouro_fiscal || '',
        numero_tomador: d.numero_filial || d.numero_fiscal || 'S/N',
        bairro_tomador: d.bairro_filial || d.bairro_fiscal || '',
        cep_tomador: d.cep_filial || d.cep_fiscal || '',
        codigo_municipio_tomador: d.codigo_municipio_ibge_filial || d.codigo_municipio_ibge || '',
        clocprestacao: d.codigo_ibge_atendimento || d.codigo_municipio_ibge_filial || d.codigo_municipio_ibge || '',
        informacoes_complementares: 'Empresa optante pelo Simples Nacional, conforme Lei Complementar n 123/2006. ISS recolhido na forma do Simples Nacional, sem retencao. Pagamento por boleto ou transferencia bancaria: CNPJ 41257062000160 - PIX Banco Inter, Agencia 0001, Conta 114204446',
      });
      setEtapaNFSe(0);
      setModalNFSe(true);
    } catch(e) { message.error('Erro ao carregar dados'); }
  };

  const emitirNFSe = async () => {
    try {
      setEmitindoNFSe(true);
      await api.post('/nfse/proposta/' + id, dadosNFSeRevisao);
      message.success('NFS-e emitida com sucesso!');
      setModalNFSe(false);
      setDadosNFSeRevisao(null);
      setEtapaNFSe(0);
      formNFSe.resetFields();
      const rn = await api.get('/nfse/proposta/' + id);
      setNfses(rn.data || []);
    } catch(e) { message.error('Erro ao emitir: ' + (e.response?.data?.erro || e.message)); }
    finally { setEmitindoNFSe(false); }
  };

  const cancelarBoleto = async () => {
    try {
      await api.post('/boletos/' + boletoCancelarId + '/cancelar', { motivo: motivoCancelamento });
      message.success('Boleto cancelado!');
      setModalCancelar(false);
      const r = await api.get('/boletos/proposta/' + id);
      setBoletos(r.data || []);
    } catch(e) { message.error('Erro ao cancelar: ' + (e.response?.data?.erro || e.message)); }
  };

  const consultarStatus = async (boletoId) => {
    try {
      await api.get('/boletos/' + boletoId + '/status');
      message.success('Status atualizado!');
      const r = await api.get('/boletos/proposta/' + id);
      setBoletos(r.data || []);
    } catch(e) { message.error('Erro ao consultar status'); }
  };

  const verBoleto = async (boletoId) => {
    try {
      const r = await api.get('/boletos/' + boletoId + '/pdf');
      setDadosBoleto(r.data);
      setModalDadosBoleto(true);
    } catch { message.error('Erro ao abrir boleto'); }
  };

  const baixarPDFBoleto = async (boletoId, numero) => {
    try {
      message.loading({ content: 'Gerando PDF...', key: 'pdfboleto', duration: 0 });
      const r = await api.get('/boletos/' + boletoId + '/pdf/gerar', { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
      message.success({ content: 'PDF gerado!', key: 'pdfboleto' });
    } catch { message.error({ content: 'Erro ao gerar PDF', key: 'pdfboleto' }); }
  };

  const reenviarEmail = async (boletoId) => {
    try {
      await api.post('/boletos/' + boletoId + '/reenviar-email');
      message.success('Email reenviado!');
    } catch { message.error('Erro ao reenviar email'); }
  };

  const gerarOS = async (values) => {
    try {
      const r = await api.post('/os', {
        proposta_id: id,
        endereco_atendimento: proposta.end_logradouro ? proposta.end_logradouro + ', ' + proposta.end_numero + ' - ' + proposta.end_bairro + ', ' + proposta.end_cidade + '/' + proposta.end_estado : '',
        observacoes: '',
      });
      message.success('OS ' + r.data.numero + ' criada! Abrindo editor...');
      setModalOS(false);
      navigate('/agendamentos?os=' + r.data.id);
    } catch { message.error('Erro ao gerar OS'); }
  };





  const gerarPDF = async () => {
    try {
      setGerandoPDF(true);
      const response = await api.get(`/propostas/${id}/pdf`, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `Proposta-${proposta.numero}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      message.success('PDF gerado com sucesso!');
    } catch { message.error('Erro ao gerar PDF'); }
    finally { setGerandoPDF(false); }
  };

  const fmt = (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;

  if (loading) return <div style={{ padding: 24 }}>Carregando...</div>;
  if (!proposta) return <div style={{ padding: 24 }}>Proposta não encontrada.</div>;

  const colunasItens = [
    { title: 'Serviço', render: (_, r) => `${r.nome}${r.equipamento ? ' — ' + r.equipamento : ''}` },
    { title: 'Tipo', dataIndex: 'tipo', render: (v) => <Tag color={v === 'inspecao' ? 'blue' : v === 'calibracao' ? 'green' : 'default'}>{v === 'inspecao' ? 'Inspeção' : v === 'calibracao' ? 'Calibração' : 'Outros'}</Tag> },
    { title: 'Qtd', dataIndex: 'quantidade', width: 60 },
    { title: 'Valor Base', dataIndex: 'valor_base', render: (v) => fmt(v) },
    { title: 'Mobilização', dataIndex: 'custo_mobilizacao', render: (v) => fmt(v) },
    { title: 'ART', dataIndex: 'custo_art', render: (v) => fmt(v) },
    { title: 'Vl. Unit.', dataIndex: 'valor_unitario', render: (v) => <Text strong>{fmt(v)}</Text> },
    { title: 'Total', dataIndex: 'valor_total', render: (v) => <Text strong style={{ color: '#1a3c5e' }}>{fmt(v)}</Text> },
  ];

  return (
    <>
      <PainelAssinaturas tipo="servico" id={id} proposta={proposta}
        onMudou={carregarProposta} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate(proposta?.cliente_id ? '/clientes/' + proposta.cliente_id : '/propostas')}>Voltar</Button>
          <Title level={4} style={{ margin: 0 }}>Proposta {proposta.numero}</Title>
          <Tag color={STATUS_CORES[proposta.status]} style={{ fontSize: 14 }}>{STATUS_LABELS[proposta.status]}</Tag>
          <Tag>Revisão {proposta.versao}</Tag>
        </div>
        <Space>
          <Button icon={<EditOutlined />} onClick={() => navigate(`/propostas/${id}/editar`)}>Editar</Button>
          <Button icon={<FilePdfOutlined />} type="primary" onClick={gerarPDF} loading={gerandoPDF}>Gerar PDF</Button>
          <BotoesAssinatura tipo="servico" id={id} proposta={proposta} />
          <Button icon={<CalendarOutlined />} onClick={async () => {
              try {
                const r = await api.post('/os', {
                  proposta_id: id,
                  endereco_atendimento: proposta.end_logradouro ? proposta.end_logradouro + ', ' + proposta.end_numero + ' - ' + proposta.end_bairro + ', ' + proposta.end_cidade + '/' + proposta.end_estado : '',
                  observacoes: '',
                });
                message.success('OS ' + r.data.numero + ' criada!');
                window.location.href = '/agendamentos?os=' + r.data.id;
              } catch { message.error('Erro ao gerar OS'); }
            }}>Gerar OS</Button>
          <Select value={proposta.status} onChange={atualizarStatus} style={{ width: 180 }}>
            {Object.entries(STATUS_LABELS).map(([k, v]) => <Option key={k} value={k}>{v}</Option>)}
          </Select>
        </Space>
      </div>

      <Row gutter={[16, 16]}>
        <Col span={16}>
          <Card title="Dados do Cliente" size="small" style={{ marginBottom: 16 }}>
            <Descriptions column={2} size="small">
              <Descriptions.Item label="Grupo/Cliente">{proposta.razao_social || proposta.nome_cliente}</Descriptions.Item>
              <Descriptions.Item label="CNPJ Faturamento">{proposta.cnpj_faturamento || '-'}</Descriptions.Item>
              <Descriptions.Item label="Razão Social Faturamento" span={2}>{proposta.razao_faturamento || proposta.razao_social || '-'}</Descriptions.Item>
              <Descriptions.Item label="Endereço Fiscal" span={2}>{proposta.logradouro_fiscal ? `${proposta.logradouro_fiscal}, ${proposta.numero_fiscal || ''}, ${proposta.cidade_fiscal || ''} - ${proposta.estado_fiscal || ''}` : '-'}</Descriptions.Item>
              <Descriptions.Item label="Local Atendimento" span={2}>{proposta.end_nome_local ? `${proposta.end_nome_local} — ${proposta.end_logradouro}, ${proposta.end_numero}, ${proposta.end_cidade}/${proposta.end_estado}` : '-'}</Descriptions.Item>
              <Descriptions.Item label="Contato">{proposta.contato_nome ? `${proposta.contato_nome}${proposta.contato_setor ? ' — ' + proposta.contato_setor : ''}` : '-'}</Descriptions.Item>
              <Descriptions.Item label="Telefone/E-mail">{proposta.contato_telefone || '-'} {proposta.contato_email ? `| ${proposta.contato_email}` : ''}</Descriptions.Item>
            </Descriptions>
          </Card>

          <Card title="Itens da Proposta" size="small" style={{ marginBottom: 16 }}>
            <Table size="small" pagination={false} dataSource={proposta.itens || []} rowKey="id" columns={colunasItens} />
          </Card>

          <Card size="small">
            <Row>
              <Col span={12}>
                {(() => {
                  const td = proposta.tipo_deslocamento;
                  const n = (v) => v !== null && v !== undefined && v !== '' && Number(v) !== 0;
                  const num = (v) => String(Number(v)).replace('.', ',');
                  const linha = (rot, val) => <div key={rot}><Text type="secondary">{rot}: <Text strong>{val}</Text></Text></div>;
                  const L = [linha('Deslocamento', td === 'viagem' ? 'Viagem (com pernoite)' : td === 'celum' ? 'Entrega e retirada na Celum' : 'Perto (sem pernoite)')];
                  if (n(proposta.dias_execucao)) L.push(linha('Dias de execução', num(proposta.dias_execucao)));
                  if (td !== 'celum') {
                    if (n(proposta.horas_deslocamento)) L.push(linha('Horas deslocamento (ida+volta)', num(proposta.horas_deslocamento) + ' h'));
                    if (td === 'viagem') {
                      if (n(proposta.km_viagem)) L.push(linha('Km total viagem (ida+volta)', num(proposta.km_viagem) + ' km'));
                      if (n(proposta.dias_totais_viagem)) L.push(linha('Dias totais', num(proposta.dias_totais_viagem)));
                      if (n(proposta.pedagio_valor)) L.push(linha('Pedágio (total)', fmt(proposta.pedagio_valor)));
                      if (n(proposta.diarias_aluguel_carro)) L.push(linha('Diárias aluguel carro', num(proposta.diarias_aluguel_carro)));
                      if (n(proposta.km_deslocamento_local)) L.push(linha('Km deslocamento local (ida+volta/dia)', num(proposta.km_deslocamento_local) + ' km'));
                    } else {
                      if (n(proposta.distancia_km)) L.push(linha('Distância (ida+volta)', num(proposta.distancia_km) + ' km'));
                      if (n(proposta.pedagio_valor)) L.push(linha('Pedágio (ida+volta)', fmt(proposta.pedagio_valor)));
                      if (n(proposta.horas_estacionamento)) L.push(linha('Horas estacionamento', num(proposta.horas_estacionamento) + ' h'));
                    }
                  }
                  L.push(linha('ART no cálculo', proposta.incluir_art ? 'Sim' : 'Não'));
                  return L;
                })()}
                {proposta.crea_fora_mg && <Tag color="orange" style={{ marginTop: 4 }}>CREA fora de MG</Tag>}
              </Col>
              <Col span={12} style={{ textAlign: 'right' }}>
                <div><Text>Subtotal: <Text strong>{fmt(proposta.subtotal)}</Text></Text></div>
                {parseFloat(proposta.desconto) > 0 && (
                  <div><Text style={{ color: 'red' }}>Desconto: - <Text strong>{fmt(proposta.desconto)}</Text></Text>
                  {proposta.desconto_observacao && <Text type="secondary"> ({proposta.desconto_observacao})</Text>}</div>
                )}
                <div><Text>Imposto: <Text strong>{fmt(proposta.valor_imposto)}</Text></Text></div>
                <Divider style={{ margin: '8px 0' }} />
                <Title level={3} style={{ color: '#1a3c5e', margin: 0 }}>TOTAL: {fmt(proposta.valor_total)}</Title>
              </Col>
            </Row>
          </Card>
        </Col>

        <Col span={8}>
          <Card title="Informações da Proposta" size="small" style={{ marginBottom: 16 }}>
            <Descriptions column={1} size="small">
              <Descriptions.Item label="Número">{proposta.numero}</Descriptions.Item>
              <Descriptions.Item label="Revisão">{proposta.versao}</Descriptions.Item>
              <Descriptions.Item label="Título">{proposta.titulo_contrato}</Descriptions.Item>
              <Descriptions.Item label="Data">{new Date(proposta.criado_em).toLocaleDateString('pt-BR')}</Descriptions.Item>
              <Descriptions.Item label="Validade">{proposta.validade_dias} dias</Descriptions.Item>
              <Descriptions.Item label="Forma Pgto">{proposta.forma_pagamento || '-'}</Descriptions.Item>
            </Descriptions>
          </Card>

          <Card title="Peças (faturadas separadamente)" size="small" style={{ marginBottom: 16 }}>
            <Select
              style={{ width: '100%' }}
              allowClear
              showSearch
              optionFilterProp="children"
              placeholder="Vincular proposta de produto"
              loading={salvandoPecas}
              value={proposta.proposta_produto_id || undefined}
              onChange={async (v) => {
                setSalvandoPecas(true);
                try {
                  await api.put('/propostas/' + id + '/pecas', { proposta_produto_id: v || null });
                  message.success(v ? 'Peças vinculadas à proposta' : 'Peças desvinculadas');
                  carregarProposta();
                } catch (e) { message.error(e.response?.data?.erro || 'Erro ao vincular peças'); }
                finally { setSalvandoPecas(false); }
              }}
            >
              {propostasProduto.map(pp => <Option key={pp.id} value={pp.id}>{pp.numero}{pp.titulo ? ' — ' + pp.titulo : ''} ({fmt(pp.valor_total)})</Option>)}
            </Select>
            {proposta.pecas && (
              <div style={{ marginTop: 8 }}>
                <Text type="secondary">{(proposta.pecas.itens || []).length} item(ns) — Total peças: </Text><Text strong>{fmt(proposta.pecas.subtotal)}</Text>
                <br /><Text type="secondary">Total geral (serviços + peças): </Text><Text strong style={{ color: '#1a3c5e' }}>{fmt(parseFloat(proposta.valor_total || 0) + parseFloat(proposta.pecas.subtotal || 0))}</Text>
                <br /><Button type="link" size="small" style={{ padding: 0 }} onClick={() => navigate('/propostas-produtos/' + proposta.proposta_produto_id)}>Abrir proposta {proposta.pecas.numero}</Button>
              </div>
            )}
            <div style={{ marginTop: 6 }}><Text type="secondary" style={{ fontSize: 12 }}>No PDF, as peças aparecem na mesma tabela dos serviços, com total geral. NFS-e e boleto desta proposta seguem só com os serviços.</Text></div>
          </Card>

          <Card title="Ordem de Compra" size="small" style={{ marginBottom: 16 }} extra={
            <Space size={4}>
              {proposta.arquivo_oc && <Button size="small" onClick={verArquivoOC}>Ver Arquivo</Button>}
              <Upload beforeUpload={uploadOC} showUploadList={false} accept=".pdf,.jpg,.jpeg,.png">
                <Button size="small" icon={<UploadOutlined />} loading={uploadingOC}>Anexar OC</Button>
              </Upload>
              {!editandoOC && <Button icon={<EditOutlined />} size="small" onClick={() => setEditandoOC(true)}>Registrar</Button>}
            </Space>
          }>
            {editandoOC ? (
              <Space.Compact style={{ width: '100%' }}>
                <Input value={numeroOC} onChange={(e) => setNumeroOC(e.target.value)} placeholder="Número da OC do cliente" />
                <Button type="primary" icon={<SaveOutlined />} onClick={salvarOC}>Salvar</Button>
              </Space.Compact>
            ) : (
              <Text>{proposta.numero_oc || <Text type="secondary">Aguardando OC do cliente</Text>}</Text>
            )}
          </Card>

          {proposta.observacoes && (
            <Card title="Observações Internas" size="small">
              <Text>{proposta.observacoes}</Text>
            </Card>
          )}
        </Col>
      </Row>

    <Modal title={`Gerar OS — ${proposta.razao_social || proposta.nome_cliente || ""}`} open={modalOS} onCancel={() => setModalOS(false)} footer={null} width={680}>
      <Form form={formOS} layout="vertical" onFinish={gerarOS}>
        <div style={{ background: '#f6f6f6', padding: 8, borderRadius: 6, marginBottom: 12, fontSize: 13 }}>
          <strong>Proposta:</strong> {proposta.numero} — {proposta.titulo_contrato || ''}<br/>
          <strong>Cliente:</strong> {proposta.razao_social || proposta.nome_cliente}<br/>
          {proposta.end_cidade && <span><strong>Local:</strong> {proposta.end_cidade}/{proposta.end_estado}</span>}
        </div>
        <Form.Item name="data_agendada" label="Data e Hora Agendada">
          <DatePicker showTime format="DD/MM/YYYY HH:mm" style={{ width: '100%' }} />
        </Form.Item>
        <Form.Item noStyle shouldUpdate>{() => (<Form.Item name="contato_id" label="Contato"><ContatoSelect clienteId={proposta?.cliente_id} /></Form.Item>)}</Form.Item>
        <Form.Item name="tecnico" label="Técnico Responsável">
          <AntInput placeholder="Nome do técnico" />
        </Form.Item>
        <Form.Item name="endereco_atendimento" label="Endereço de Atendimento" rules={[{ required: true, message: 'Informe o endereço' }]}>
          <AntInput.TextArea rows={2} placeholder="Endereço onde o técnico deve comparecer" />
        </Form.Item>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={() => setModalOS(false)}>Cancelar</Button>
          <Button type="primary" htmlType="submit" icon={<CalendarOutlined />}>Criar OS</Button>
        </div>
      </Form>
    </Modal>

    {/* Card Boletos */}
    <Card title={`Boletos (${boletos.length})`} size="small" style={{ marginTop: 16 }}
      extra={<Button type="primary" icon={<DollarOutlined />} onClick={() => { formBoleto.resetFields(); setModalBoleto(true); }}>Emitir Boleto</Button>}>
      <Table
        dataSource={boletos}
        rowKey="id"
        size="small"
        locale={{ emptyText: 'Nenhum boleto emitido.' }}
        columns={[
          { title: 'Ações', width: 160, render: (_, r) => (
            <Space size={2}>
              <Button size="small" icon={<FilePdfOutlined />} onClick={() => verBoleto(r.id)} title="Ver dados do boleto" />
                <Button size="small" icon={<DownloadOutlined />} style={{color:'#1a3c5e',borderColor:'#1a3c5e'}} onClick={() => baixarPDFBoleto(r.id)} title="Baixar PDF do boleto" />
              <Button size="small" icon={<MailOutlined />} onClick={() => reenviarEmail(r.id)} title="Reenviar Email" />
              <Button size="small" icon={<ReloadOutlined />} onClick={() => consultarStatus(r.id)} title="Atualizar Status" />
              {r.status === 'emitido' && <Button size="small" danger icon={<StopOutlined />} title="Cancelar" onClick={() => { setBoletoCancelarId(r.id); setMotivoCancelamento('ACERTOS'); setModalCancelar(true); }} />}
            </Space>
          )},
          { title: 'Valor', dataIndex: 'valor', width: 100, render: (v) => 'R$ ' + parseFloat(v).toFixed(2).replace('.', ',') },
          { title: 'Vencimento', dataIndex: 'vencimento', width: 110, render: (v) => v ? new Date(v).toLocaleDateString('pt-BR') : '-' },
          { title: 'Status', dataIndex: 'status', width: 100, render: (v) => {
            const cores = { emitido: 'blue', pago: 'green', cancelado: 'red', expirado: 'orange' };
            const labels = { emitido: 'Emitido', pago: 'Pago', cancelado: 'Cancelado', expirado: 'Expirado' };
            return <Tag color={cores[v] || 'default'}>{labels[v] || v}</Tag>;
          }},
          { title: 'Email', dataIndex: 'enviado_email', width: 80, render: (v) => v ? <Tag color="green">Enviado</Tag> : <Tag>Pendente</Tag> },
          { title: 'Emitido em', dataIndex: 'criado_em', width: 130, render: (v) => v ? new Date(v).toLocaleString('pt-BR') : '-' },
        ]}
      />
    </Card>

    {/* Card NFS-e */}
    <Card title={`Notas Fiscais (${nfses.length})`} size="small" style={{ marginTop: 16 }}
      extra={<Button type="primary" icon={<FileProtectOutlined />} onClick={abrirModalNFSe}>Emitir NFS-e</Button>}>
      <Table
        dataSource={nfses}
        rowKey="id"
        size="small"
        locale={{ emptyText: 'Nenhuma NFS-e emitida.' }}
        columns={[
          { title: 'Ações', width: 120, render: (_, r) => (
            <Space size={2}>
              {r.status === 'emitida' && <Button size="small" icon={<DownloadOutlined />} title="Baixar XML" onClick={async () => {
                const token = localStorage.getItem('token');
                const response = await fetch('/api/nfse/' + r.id + '/xml', { headers: { Authorization: 'Bearer ' + token } });
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a'); a.href = url; a.download = 'NFSe-' + r.numero_nfse + '.xml'; a.click();
              }} />}
              {r.status === 'emitida' && <Button size="small" icon={<FilePdfOutlined />} title="Baixar PDF" onClick={async () => {
                const token = localStorage.getItem('token');
                const response = await fetch('/api/nfse/' + r.id + '/pdf-url', { headers: { Authorization: 'Bearer ' + token } });
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);
                const a = document.createElement('a'); a.href = url; a.download = 'NFSe-' + r.numero_nfse + '.pdf'; a.click();
              }} />}
              {r.status === 'emitida' && <Button size="small" danger icon={<StopOutlined />} title="Cancelar" onClick={async () => {
                const motivo = prompt('Motivo do cancelamento:');
                if (!motivo) return;
                try {
                  await api.post('/nfse/' + r.id + '/cancelar', { motivo });
                  message.success('NFS-e cancelada!');
                  const rn = await api.get('/nfse/proposta/' + id);
                  setNfses(rn.data || []);
                } catch(e) { message.error('Erro: ' + (e.response?.data?.erro || e.message)); }
              }} />}
            </Space>
          )},
          { title: 'NFS-e', dataIndex: 'numero_nfse', width: 90, render: v => v ? <Tag color="blue">{v}</Tag> : '-' },
          { title: 'Valor', dataIndex: 'valor_servico', width: 110, render: v => 'R$ ' + parseFloat(v||0).toFixed(2).replace('.',',') },
          { title: 'Status', dataIndex: 'status', width: 100, render: v => {
            const cores = { emitida: 'green', cancelada: 'red', erro: 'error', processando: 'processing', pendente: 'default' };
            const labels = { emitida: 'Emitida', cancelada: 'Cancelada', erro: 'Erro', processando: 'Processando', pendente: 'Pendente' };
            return <Tag color={cores[v]||'default'}>{labels[v]||v}</Tag>;
          }},
          { title: 'Emitida em', dataIndex: 'criado_em', width: 130, render: v => v ? new Date(v).toLocaleString('pt-BR') : '-' },
        ]}
      />
    </Card>

    {/* Modal NFS-e */}
    <Modal title="Emitir NFS-e" open={modalNFSe} onCancel={() => { setModalNFSe(false); setEtapaNFSe(0); formNFSe.resetFields(); }}
      footer={null} width={700} destroyOnClose>
      <Steps current={etapaNFSe} size="small" style={{ marginBottom: 24 }}
        items={[{ title: 'Dados' }, { title: 'Revisão' }]} />
      {etapaNFSe === 0 && (
        <Form form={formNFSe} layout="vertical" onFinish={(values) => { setDadosNFSeRevisao(values); setEtapaNFSe(1); }}>
          <Form.Item name="clocprestacao" hidden><Input /></Form.Item>
          <Form.Item name="estado_tomador" hidden><Input /></Form.Item>
          <Form.Item name="numero_proposta" hidden><Input /></Form.Item>
          <Form.Item name="logradouro_tomador" hidden><Input /></Form.Item>
          <Form.Item name="numero_tomador" hidden><Input /></Form.Item>
          <Form.Item name="bairro_tomador" hidden><Input /></Form.Item>
          <Form.Item name="complemento_tomador" hidden><Input /></Form.Item>
          <Form.Item name="descricao_servico" label="Descrição do Serviço" rules={[{ required: true }]}>
            <Input.TextArea rows={2} />
          </Form.Item>
          <div style={{ display: 'flex', gap: 12 }}>
            <Form.Item name="valor_servico" label="Valor (R$)" style={{ flex: 1 }} rules={[{ required: true }]}>
              <InputNumber style={{ width: '100%' }} min={0} precision={2} />
            </Form.Item>
            <Form.Item name="aliquota_simples" label="Alíquota Simples (%)" style={{ flex: 1 }} rules={[{ required: true }]}>
              <InputNumber style={{ width: '100%' }} min={0} max={100} precision={2} />
            </Form.Item>
            <Form.Item name="retencao_issqn" label="Retenção ISSQN" style={{ flex: 1 }}>
              <Select><Select.Option value={false}>Não retido</Select.Option><Select.Option value={true}>Retido</Select.Option></Select>
            </Form.Item>
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <Form.Item name="numero_pedido" label="Nº Pedido/OC" style={{ flex: 1 }}><Input /></Form.Item>
            <Form.Item name="prazo_pagamento" label="Prazo de Pagamento" style={{ flex: 2 }}><Input /></Form.Item>
          </div>
          <Form.Item name="informacoes_complementares" label="Informações Complementares">
            <Input.TextArea rows={3} />
          </Form.Item>
          <div style={{ display: 'flex', gap: 12 }}>
            <Form.Item name="cnpj_tomador" label="CNPJ Tomador" style={{ flex: 1 }} rules={[{ required: true }]}><Input /></Form.Item>
            <Form.Item name="razao_social_tomador" label="Razão Social" style={{ flex: 2 }} rules={[{ required: true }]}><Input /></Form.Item>
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <Form.Item name="cep_tomador" label="CEP" style={{ flex: 1 }}><Input /></Form.Item>
            <Form.Item name="codigo_municipio_tomador" label="Cód. IBGE" style={{ flex: 1 }} rules={[{ required: true }]}><Input /></Form.Item>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
            <Button type="primary" htmlType="submit">Revisar →</Button>
          </div>
        </Form>
      )}
      {etapaNFSe === 1 && dadosNFSeRevisao && (
        <div>
          <Descriptions bordered size="small" column={2} style={{ marginBottom: 16 }}>
            <Descriptions.Item label="Descrição" span={2}>{dadosNFSeRevisao.descricao_servico}</Descriptions.Item>
            <Descriptions.Item label="Valor">R$ {parseFloat(dadosNFSeRevisao.valor_servico||0).toFixed(2).replace('.',',')}</Descriptions.Item>
            <Descriptions.Item label="Alíquota">{dadosNFSeRevisao.aliquota_simples}%</Descriptions.Item>
            <Descriptions.Item label="CNPJ Tomador">{dadosNFSeRevisao.cnpj_tomador}</Descriptions.Item>
            <Descriptions.Item label="Tomador">{dadosNFSeRevisao.razao_social_tomador}</Descriptions.Item>
            <Descriptions.Item label="Cód. IBGE">{dadosNFSeRevisao.codigo_municipio_tomador}</Descriptions.Item>
            <Descriptions.Item label="Nº Pedido/OC">{dadosNFSeRevisao.numero_pedido || '-'}</Descriptions.Item>
            <Descriptions.Item label="Prazo Pagamento" span={2}>{dadosNFSeRevisao.prazo_pagamento || '-'}</Descriptions.Item>
          </Descriptions>
          <div style={{ background: '#fff7e6', padding: 8, borderRadius: 6, marginBottom: 12, fontSize: 12 }}>
            ⚠️ Esta ação emitirá uma NFS-e com validade fiscal real.
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Button onClick={() => setEtapaNFSe(0)}>← Voltar</Button>
            <Popconfirm title="Confirma a emissão da NFS-e?" description="Nota fiscal com validade fiscal real."
              onConfirm={emitirNFSe} okText="Sim, emitir" cancelText="Não" okButtonProps={{ danger: true }}>
              <Button type="primary" loading={emitindoNFSe} danger icon={<FileProtectOutlined />}>Confirmar e Emitir</Button>
            </Popconfirm>
          </div>
        </div>
      )}
    </Modal>

    {/* Modal Cancelar Boleto */}
    <Modal title="Cancelar Boleto" open={modalCancelar} onCancel={() => setModalCancelar(false)}
      onOk={cancelarBoleto} okText="Cancelar Boleto" okButtonProps={{ danger: true }} cancelText="Voltar">
      <p style={{ marginBottom: 12 }}>Selecione o motivo do cancelamento:</p>
      <Select value={motivoCancelamento} onChange={setMotivoCancelamento} style={{ width: '100%' }}>
        <Option value="ACERTOS">Acertos</Option>
        <Option value="PAGODIRETOAOCLIENTE">Pago direto ao cliente</Option>
        <Option value="SUBSTITUICAO">Substituição</Option>
      </Select>
    </Modal>

    {/* Modal Dados Boleto */}
    <Modal title="Dados do Boleto" open={modalDadosBoleto} onCancel={() => setModalDadosBoleto(false)} footer={<Button onClick={() => setModalDadosBoleto(false)}>Fechar</Button>} width={680}>
      {dadosBoleto && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div><Text strong>Valor:</Text> R$ {parseFloat(dadosBoleto.valor||0).toFixed(2).replace('.',',')}</div>
          <div><Text strong>Vencimento:</Text> {dadosBoleto.vencimento ? new Date(dadosBoleto.vencimento).toLocaleDateString('pt-BR') : '-'}</div>
          <div><Text strong>Nosso Número:</Text> {dadosBoleto.nosso_numero}</div>
          <div>
            <Text strong>Linha Digitável:</Text>
            <Input.Search value={dadosBoleto.linha_digitavel} readOnly enterButton="Copiar"
              onSearch={() => { navigator.clipboard.writeText(dadosBoleto.linha_digitavel); message.success('Copiado!'); }} />
          </div>
          <div>
            <Text strong>Código de Barras:</Text>
            <Input.Search value={dadosBoleto.codigo_barras} readOnly enterButton="Copiar"
              onSearch={() => { navigator.clipboard.writeText(dadosBoleto.codigo_barras); message.success('Copiado!'); }} />
          </div>
          {dadosBoleto.pix_copia_cola && <div>
            <Text strong>PIX Copia e Cola:</Text>
            <Input.Search value={dadosBoleto.pix_copia_cola} readOnly enterButton="Copiar"
              onSearch={() => { navigator.clipboard.writeText(dadosBoleto.pix_copia_cola); message.success('Copiado!'); }} />
          </div>}
        </div>
      )}
    </Modal>

    {/* Modal Boleto */}
    <Modal title="Emitir Boleto" open={modalBoleto} onCancel={() => setModalBoleto(false)} footer={null} width={560}>
      <Form form={formBoleto} layout="vertical" onFinish={emitirBoleto}
        initialValues={{ multa_percentual: 5, juros_percentual: 2, desconto_percentual: 0, tipo_boleto: 'unico', fim_recorrencia: 'nunca', codigo_controle: proposta?.numero, descricao: proposta?.titulo }}>
        <Row gutter={12}>
          <Col span={12}><Form.Item name="codigo_controle" label="Código de Controle"><Input /></Form.Item></Col>
          <Col span={12}><Form.Item name="descricao" label="Descrição"><Input /></Form.Item></Col>
        </Row>
        <Form.Item name="tipo_boleto" label="Tipo de Boleto" rules={[{ required: true }]}>
          <Select>
            <Option value="unico">Único</Option>
            <Option value="recorrente">Recorrente</Option>
            <Option value="parcelado">Parcelado</Option>
          </Select>
        </Form.Item>
        <Form.Item name="valor" label={`Valor (padrão: R$ ${parseFloat(proposta?.valor_total||0).toFixed(2).replace('.',',')})`}>
          <Input type="number" step="0.01" placeholder="Deixe vazio para usar valor da proposta" />
        </Form.Item>
        <Form.Item shouldUpdate={(prev, curr) => prev.tipo_boleto !== curr.tipo_boleto} noStyle>
          {({ getFieldValue }) => {
            const tipo = getFieldValue('tipo_boleto');
            return <>
              {(tipo === 'unico' || tipo === 'parcelado') && (
                <Form.Item name="vencimento" label="Data de Vencimento" rules={[{ required: true }]}>
                  <DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} />
                </Form.Item>
              )}
              {tipo === 'recorrente' && (<>
                <Row gutter={12}>
                  <Col span={12}><Form.Item name="data_primeira_emissao" label="Data Primeira Emissão" rules={[{ required: true }]}><DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} /></Form.Item></Col>
                  <Col span={12}><Form.Item name="vencimento" label="Data de Vencimento" rules={[{ required: true }]}><DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} /></Form.Item></Col>
                </Row>
                <Form.Item name="recorrencia" label="Recorrência" rules={[{ required: true }]}>
                  <Select>
                    <Option value="SEMANAL">Semanal</Option>
                    <Option value="QUINZENAL">Quinzenal</Option>
                    <Option value="MENSAL">Mensal</Option>
                    <Option value="BIMESTRAL">Bimestral</Option>
                    <Option value="TRIMESTRAL">Trimestral</Option>
                    <Option value="SEMESTRAL">Semestral</Option>
                    <Option value="ANUAL">Anual</Option>
                  </Select>
                </Form.Item>
                <Form.Item name="fim_recorrencia" label="Fim da Cobrança">
                  <Select>
                    <Option value="nunca">Nunca</Option>
                    <Option value="data">Em uma data específica</Option>
                    <Option value="ocorrencias">Após N ocorrências</Option>
                  </Select>
                </Form.Item>
                <Form.Item shouldUpdate={(prev, curr) => prev.fim_recorrencia !== curr.fim_recorrencia} noStyle>
                  {({ getFieldValue: gfv }) => {
                    const fim = gfv('fim_recorrencia');
                    if (fim === 'data') return <Form.Item name="data_fim_recorrencia" label="Data Fim"><DatePicker format="DD/MM/YYYY" style={{ width: '100%' }} /></Form.Item>;
                    if (fim === 'ocorrencias') return <Form.Item name="qtd_ocorrencias" label="Quantidade de Ocorrências"><Input type="number" /></Form.Item>;
                    return null;
                  }}
                </Form.Item>
              </>)}
            </>;
          }}
        </Form.Item>
        <Row gutter={8}>
          <Col span={6}><Form.Item name="multa_tipo" label="Tipo Multa" initialValue="PERCENTUAL"><Select><Option value="PERCENTUAL">%</Option><Option value="VALOR">R$</Option></Select></Form.Item></Col>
          <Col span={6}><Form.Item name="multa_percentual" label="Multa"><Input type="number" step="0.01" /></Form.Item></Col>
          <Col span={6}><Form.Item name="juros_tipo" label="Tipo Juros" initialValue="PERCENTUAL"><Select><Option value="PERCENTUAL">% mensal</Option><Option value="VALOR">R$/dia</Option></Select></Form.Item></Col>
          <Col span={6}><Form.Item name="juros_percentual" label="Juros"><Input type="number" step="0.01" /></Form.Item></Col>
        </Row>
        <Row gutter={12}>
          <Col span={12}><Form.Item name="desconto_percentual" label="Desconto (%)"><Input type="number" step="0.01" /></Form.Item></Col>
        </Row>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <Button onClick={() => setModalBoleto(false)}>Cancelar</Button>
          <Button type="primary" htmlType="submit" loading={gerandoBoleto} icon={<DollarOutlined />}>Emitir e Enviar</Button>
        </div>
      </Form>
    </Modal>

  </>
  );
}

export default PropostaDetalhe;
